import React from 'react';
import PanelInputField from '../PanelInputField';
import { useTranslation } from 'react-i18next';
import PromptSuggestionSlider from './PromptSuggestionSlider';
import LabelText from '../LabelText';
const PromptSuggestionsField = ({ suggestions })=>{
    const { t } = useTranslation('dreamup');
    return /*#__PURE__*/ React.createElement(PanelInputField, {
        rootTag: "div",
        label: /*#__PURE__*/ React.createElement(LabelText, null, t('dreamup.header.settingsPanel.promptSuggestions.label')),
        input: /*#__PURE__*/ React.createElement(PromptSuggestionSlider, {
            suggestions: suggestions
        })
    });
};
PromptSuggestionsField.displayName = 'PromptSuggestionsField';
export default PromptSuggestionsField;

//# sourceMappingURL=PromptSuggestionsField.js.map